import { Check, X } from "lucide-react";
import {
  type WorkflowStepUserResponse,
  WorkflowStepUserResponses,
} from "~/api/types";

export function ActionIndicator({
  response,
}: {
  response: WorkflowStepUserResponse;
}) {
  switch (response) {
    case WorkflowStepUserResponses.approved:
      return (
        <span className="text-success-foreground flex items-center">
          <Check className="size-3" />
        </span>
      );
    case WorkflowStepUserResponses.rejected:
      return (
        <span className="text-destructive-foreground flex items-center">
          <X className="size-3" />
        </span>
      );
    case WorkflowStepUserResponses.pending:
      return <span className="bg-warning inline-block size-2 rounded-full" />;
  }
}
